import axios from 'axios';

export const getImageSource = async (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    let timer = setTimeout(() => {
      clearTimeout(timer);
      timer = null;
      resolve(url);
    }, 1000);
    img.onload = () => {
      clearTimeout(timer);
      timer = null;
      resolve(url);
    };
    img.onerror = reject;
    img.src = url;
  });
};

// export const urlToBlobUrl = async (url) => {
//   if (!/^[\w]+:/.test(url) && !/^\/[\\/]?/.test(url)) return url;
//   const version = /\?/.test(url) ? `&v=${new Date().getTime()}` : `?v=${new Date().getTime()}`;

//   return new Promise((resolve, reject) => {
//     fetch(`${url}${version}`).then((response) => {
//       // Check if response is successful
//       if (!response.ok) {
//         return reject(`HTTP error! status: ${response.status}`);
//       }
//       // Get the content length from headers for progress calculation
//       response.blob().then((blob) => {
//         resolve(URL.createObjectURL(blob));
//       });
//     });
//   });
// };
export const urlToBlobUrl = async (url, retryCount = 0) => {
  if (!/^[\w]+:/.test(url) && !/^\/[\\/]?/.test(url)) return url;
  let version = /\?/.test(url) ? `&v=${new Date().getTime()}` : `?v=${new Date().getTime()}`;
  try {
    const response = await axios({
      url: `${url}${version}`,
      method: 'GET',
      responseType: 'blob',
      timeout: 5000,
    });
    return URL.createObjectURL(response.data);
  } catch (error) {
    if (retryCount < 10) {
      console.log(`图片加载失败，第${retryCount + 1}次重试: ${url} `);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return urlToBlobUrl(url, retryCount + 1);
    } else {
      return url;
    }
  }
};
export const urlToBase64 = async (url) => {
  if (!/^http/.test(url) && !/^\//.test(url)) {
    return url;
  }
  const version = /\?/.test(url) ? `& v=${new Date().getTime()} ` : ` ? v = ${new Date().getTime()} `;
  const response = await axios.get(`${url}${version}`, { responseType: 'arraybuffer' });
  let type = response.headers['content-type'];
  return `data:${type}; base64, ${window.btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))} `;
};

export function fileToBase64(file) {
  const fileReader = new FileReader();

  return new Promise((reslove, reject) => {
    fileReader.readAsDataURL(file);
    fileReader.onload = (event) => {
      console.log(event);
      reslove(event.target.result);
    };
    fileReader.onerror = reject;
  });
}

export function base64ToFile(dataURL, fileName, mimeType = null) {
  const arr = dataURL.split(',');
  const defaultMimeType = arr[0].match(/:(.*?);/)[1];
  const suffix = defaultMimeType.split('/')[1];
  const fileName0 = `${new Date().getTime()}.${suffix}`;
  const bStr = window.atob(arr[1]);
  let n = bStr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bStr.charCodeAt(n);
  }
  return new File([u8arr], fileName || fileName0, { type: mimeType || defaultMimeType });
}

export function blobToBase64(blob) {
  const a = new FileReader();
  return new Promise((resolve, reject) => {
    a.readAsDataURL(blob);
    a.onload = function b(e) {
      resolve(e.target.result);
    };
    a.onerror = reject;
  });
}

export async function urlToFile(url) {
  const base64 = await urlToBase64(url);
  return base64ToFile(base64);
}

export default { base64ToFile, fileToBase64, urlToBase64, urlToFile };
